// import node module libraries
import { Typewriter } from 'react-simple-typewriter';
import { Link } from 'react-router-dom';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import LottieFile from 'assets/images/lottie/haeppy.app_lp.lottie';

import Lottie from 'lottie-react';
import haeppyAnimation from 'assets/images/animation/haeppy_lp.json';


// import MDI icons
import Icon from '@mdi/react';
import { mdiCheck } from '@mdi/js';

const HeroTyped = () => {
	const { t } = useTranslation(); // useTranslation-Hook

	function HeroAnimation() {
		return (
			<div style={{ width: '100%', height: '100%' }}
				role="img"
				aria-label="Flows zwischen marktplätzen und Shops automatisieren"
			>
				{/*<DotLottieReact
					src={haeppyAnimation}
					loop={true}
					autoplay={true}
					renderer="canvas"
					style={{ width: '100%', height: 'auto', margin: '0 auto' }}
				/>*/}
				{<Lottie animationData={haeppyAnimation} loop={true} style={{ width: '60%', height: 'auto', margin: '0 auto', opacity: '0.4' }} />}

			</div>
		);
	}

	return (
		<section className="py-lg-18 py-10 bg-auto bg-light position-relative">
			<div className="position-absolute top-0 start-0 w-100 h-100">
				{<HeroAnimation />}
			</div>
			<Container>
				<Row className="justify-content-center" style={{ zIndex: 0, position: 'relative' }}>
					<Col xl={7} lg={7} md={12}>
						<div className="py-8 py-lg-0 text-center">
							<h1 className="display-3 fw-bold mb-3 text-primary">
								<span className="text-dark px-3 px-md-0">{t('Multi-Channel interface')}</span>
								<span className="text-primary ms-2 d-block">
									<Typewriter
										words={[
											t('automation'),
											t('optimization'),
											t('integration'),
										]}
										loop
										cursor
										cursorStyle="|"
										typeSpeed={60}
										deleteSpeed={50}
										delaySpeed={1000}
									/>
								</span>
							</h1>
							<p className="mb-6 h2 text-dark">
								{t('Turn manual tasks into automated workflows and focus on growing your e-commerce business.')}
							</p>
							<Link
								to="/authentication/sign-up"
								className="btn btn-primary me-2"
							>
								{t('Start now for free')}
							</Link>
							{<Link
								to="/marketing/pages/compare-plan/"
								className="btn btn-outline-primary"
							>
								{t('Prices & Plans')}
							</Link>}

							<div className="mt-8 mb-0">
								<ListGroup as="ul" bsPrefix="list-inline">
									<ListGroup.Item
										as="li"
										bsPrefix="list-inline-item text-dark fw-semi-bold lh-1 fs-4 me-3 mb-2 mb-md-0"
									>
										<span className="icon-shape icon-xs rounded-circle bg-light-success text-center me-2">
											<Icon
												path={mdiCheck}
												size={0.7}
												className="text-success"
											/>
										</span>
										<span className="align-middle">{t('No coding know-how required')}</span>
									</ListGroup.Item>
									<ListGroup.Item
										as="li"
										bsPrefix="list-inline-item text-dark fw-semi-bold lh-1 fs-4 me-3 mb-2 mb-md-0"
									>
										<span className="icon-shape icon-xs rounded-circle bg-light-success text-center me-2">
											<Icon
												path={mdiCheck}
												size={0.7}
												className="text-success"
											/>
										</span>
										<span className="align-middle">{t('Software-as-a-Service')}</span>
									</ListGroup.Item>
									<ListGroup.Item
										as="li"
										bsPrefix="list-inline-item text-dark fw-semi-bold lh-1 fs-4"
									>
										<span className="icon-shape icon-xs rounded-circle bg-light-success text-center me-2">
											<Icon
												path={mdiCheck}
												size={0.7}
												className="text-success"
											/>
										</span>
										<span className="align-middle">{t('Cancelable monthly')}</span>
									</ListGroup.Item>
								</ListGroup>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};
export default HeroTyped;
